module.exports = __webpack_public_path__ + "img/sDiamond7_350x350.5aa2dcd6.jpg";